import { InjectionToken } from '@angular/core';

import { HypecastOAuthConfig } from '../models/hypecast-oauth-config';

export const HYPECAST_OAUTH_CONFIG = new InjectionToken<HypecastOAuthConfig>('HYPECAST_OAUTH_CONFIG');
